import WorldForm from "@src/components/Forms/Worlds/World"
import { PageHeader } from "@src/components/PageHeader/PageHeader"
import Page from "@src/layout/Page"
import { getWorld, updateWorld } from "@src/services/requests/worlds"
import { useQuery } from "@tanstack/react-query"
import { useParams } from "react-router"

export const WorldEdit = () => {
    const { id = "" } = useParams<{ id: string }>();
    const { data: worldData } = useQuery({
        queryFn: () => getWorld(id),
        queryKey: ["worlds", id],
        enabled: id !== undefined
    });
    return <Page>
        <div className="worlds">
            <PageHeader title="Edit world" />

            <WorldForm submitFn={updateWorld} defaultValues={worldData} />
        </div>
    </Page>
}
